module.exports = __webpack_public_path__ + "static/media/main_logo.8e810cc4.png";